import React from 'react';
import { CustomIconDecrease, CustomIconIncrease } from '../icons/index';
import { IconIncrease, IconNoChange, IconDecrease } from 'src/components/BeaconV2Components/icons';

export type Direction = 'increasing' | 'decreasing' | 'neutral';

export const getDirection = (value = 0): Direction => {
  if (value === 0) {
    return 'neutral';
  }

  if (value > 0) {
    return 'increasing';
  }

  return 'decreasing';
};

/**
 * Some titles have negative emotions, so we need to invert the color
 * Example: "Ad Spend", "CPC", "CPA", "CPM", "ACOS"
 */
export const getColorForMetricChangeValue = (
  value?: number,
  direction?: Direction,
  overrideColor?: string
): string => {

  if (overrideColor) {
    return overrideColor;
  }

  if (value === 0 || direction === 'neutral') {
    return 'secondary';
  }

  if (value > 0 || direction === 'increasing') {
    return 'success';
  } else {
    return 'error';
  }
};

export const getIconForMetricChange = (value?: number, decimalPlaces?: number) => {
  if (value === undefined) {
    return IconNoChange;
  }

  if (value === 0) {
    return IconNoChange;
  }

  if (value > 0) {
    return IconIncrease;
  }

  return IconDecrease;
};

export const getIconForMetricChangeForDirection = (direction?: Direction, overrideColor?: string) => {
  if (direction === undefined) {
    return IconNoChange;
  }

  const transformAngle = 'rotate(0deg)';

  if (direction === 'neutral') {
    return IconNoChange;
  }

  return direction === 'increasing' ? (
    <CustomIconIncrease transform={transformAngle} color={overrideColor} />
  ) : (
    <CustomIconDecrease transform={transformAngle} color={overrideColor} />
  );
};
